import React, { useEffect, useState } from 'react';
import './PublishModal.scss';
import { useNavigate } from 'react-router-dom';

const formatScheduledDate = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

const PublishModal = ({ isOpen, onClose, message }) => {
  const navigate = useNavigate();
  const [linkedInUrl, setLinkedInUrl] = useState(null);
  const [displayMessage, setDisplayMessage] = useState("Your content has been published");
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduledAt, setScheduledAt] = useState(null);

  useEffect(() => {
    console.log("PublishModal received message:", message);
    let data = null;

    if (typeof message === 'string') {
      // If the string starts with '{', try to parse it as JSON.
      if (message.trim().startsWith("{")) {
        try {
          data = JSON.parse(message);
        } catch (err) {
          console.error("Failed to parse message:", err);
          // Fall back to using the string directly.
          setDisplayMessage(message);
          // Check if message contains "scheduled" to determine if it was scheduled
          setIsScheduled(message.toLowerCase().includes('scheduled'));
        }
      } else {
        // Message is a plain string, so set it as displayMessage.
        setDisplayMessage(message);
        // Check if message contains "scheduled" to determine if it was scheduled
        setIsScheduled(message.toLowerCase().includes('scheduled'));
      }
    } else if (typeof message === 'object' && message !== null) {
      data = message;
    }

    // If we successfully got an object, extract the URL and display message.
    if (data && typeof data === 'object') {
      // Check if this was a scheduled publish
      const wasScheduled = data.scheduled === true || data.response?.scheduled === true;
      setIsScheduled(wasScheduled);

      // Extract scheduled_at date
      const scheduledDate = data.scheduled_at || data.response?.scheduled_at;
      setScheduledAt(scheduledDate);

      if (data.response) {
        setLinkedInUrl(data.response.post_url || null);
        setDisplayMessage(data.response.message || data.message || "Your content has been published");
      } else {
        setLinkedInUrl(data.post_url || null);
        setDisplayMessage(data.message || "Your content has been published");
      }
    }
  }, [message]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-cs">
        <div className="close-button-container">
          <button
            className="close-button"
            style={{ border: '1px solid #EEEEEE' }}
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="model-container">
          <div className="modal-icon">
            <img
              src="/Images/check-green.svg"
              alt="icon gif"
              className="icon-gif"
            />
          </div>
          <h2 className="modal-title">{isScheduled ? 'Content Scheduled' : 'Content Published'}</h2>
          <p className="modal-message">{isScheduled ? '' : 'Congratulations! '}{displayMessage}</p>
          {isScheduled && scheduledAt && (
            <p className="scheduled-date" style={{
              fontSize: '14px',
              color: '#666',
              marginTop: '8px',
              fontWeight: '500'
            }}>
              {formatScheduledDate(scheduledAt)}
            </p>
          )}
          
          {linkedInUrl && (
            <a 
              href={linkedInUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="linkedin-button"
              style={{
                display: 'block',
                margin: '10px auto',
                padding: '8px 16px',
                background: '#0A66C2',
                color: 'white',
                borderRadius: '4px',
                textDecoration: 'none',
                textAlign: 'center',
                marginBottom: '16px'
              }}
            >
              View on LinkedIn
            </a>
          )}
          
          <button className="dashboard-button" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishModal;
